import { formatNumber } from '@utils/utils.ts';
import useOverallCreditUsage from '@features/admin-credit-usage/hooks/useOverallCreditUsage.tsx';
import styles from './index.module.scss';

function AdminCreditUsageTotals() {
  const { data, isLoading } = useOverallCreditUsage();

  const totalCredits = data?.total_credits_consumed ?? 0;
  const totalUsers = data?.total_users ?? 0;
  const avgCreditsPerUser = data?.average_credits_per_user ?? 0;
  const subscriptionLimitReached = data?.subscription_limit_reached ?? 0;
  const fallbackUsage = data?.fallback_usage ?? 0;
  const caseCredits = data?.case_credits_consumed ?? 0;
  const demandLetterCredits = data?.demand_letter_credits_consumed ?? 0;
  const depositionCredits = data?.deposition_credits_consumed ?? 0;

  return (
    <div className={styles.totalsContainer}>
      {isLoading ? (
        <div>Loading...</div>
      ) : (
        <>
          <div>
            Total Credits Consumed: <span>{formatNumber(totalCredits)}</span>
          </div>
          <div>
            Total Users: <span>{formatNumber(totalUsers)}</span>
          </div>
          <div>
            Average Credits/User: <span>{avgCreditsPerUser.toFixed(2)}</span>
          </div>
          <div>
            Case Credits: <span>{formatNumber(caseCredits)}</span>
          </div>
          <div>
            Demand Letter Credits:{' '}
            <span>{formatNumber(demandLetterCredits)}</span>
          </div>
          <div>
            Deposition Credits: <span>{formatNumber(depositionCredits)}</span>
          </div>
          <div>
            Subscription Limit Reached:{' '}
            <span>{formatNumber(subscriptionLimitReached)}</span>
          </div>
          <div>
            Fallback Usage: <span>{formatNumber(fallbackUsage)}</span>
          </div>
        </>
      )}
    </div>
  );
}

export default AdminCreditUsageTotals;
